// Models
import { Temporal } from "temporal-polyfill-lite";
import { PatchableAndDeltaSyncableODataEntity } from "../common/PatchableAndDeltaSyncableODataEntity";
// Utility
import cloneDeep from "lodash/cloneDeep";
/**
 * A base class implementation for assignments
 */ export class Assignment extends PatchableAndDeltaSyncableODataEntity {
    forSerialization() {
        return {
            id: this.id,
            "@etag": this.version,
            assignedBy: this.assignedBy,
            assignedDateTime: this.assignedDateTime.toString()
        };
    }
    getClone() {
        return new this.constructor({
            id: this.id,
            version: this.version,
            assignedBy: cloneDeep(this.assignedBy),
            assignedDateTime: Temporal.Instant.from(this.assignedDateTime),
            percentComplete: this.percentComplete,
            completedBy: cloneDeep(this.completedBy),
            completedDateTime: this.completedDateTime && Temporal.Instant.from(this.completedDateTime)
        });
    }
    isComplete() {
        return this.percentComplete === 100;
    }
    constructor(propertyBag){
        super(propertyBag);
        this.assignedBy = propertyBag.assignedBy;
        this.assignedDateTime = propertyBag.assignedDateTime ?? Temporal.Now.instant();
        this.percentComplete = propertyBag.percentComplete ?? 0;
        this.completedBy = propertyBag.completedBy ?? null;
        this.completedDateTime = propertyBag.completedDateTime ?? null;
    }
}
